import { render, staticRenderFns } from "./SalaryPayroll.vue?vue&type=template&id=c3fc340c&"
import script from "./SalaryPayroll.vue?vue&type=script&lang=js&"
export * from "./SalaryPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports